module.exports = __webpack_public_path__ + "assets/img/back.4fa2e719.png";